import { Icon } from "@iconify/react";

const AuditInfo = ({ createdAt, updatedAt, createdBy, updatedBy }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return "N/A";
    }
  };

  return (
    <div className="bg-neutral-50 rounded-3 p-3 border border-neutral-200">
      <div className="d-flex align-items-center gap-2 mb-2">
        <Icon icon="mdi:information-outline" width="18" className="text-neutral-600" />
        <span className="text-sm fw-semibold text-neutral-700">Información de auditoría</span>
      </div>
      
      <div className="row g-2">
        <div className="col-6">
          <div className="d-flex flex-column">
            <span className="text-xs text-neutral-500 mb-1">
              <Icon icon="mdi:calendar-plus" width="14" className="me-1" />
              Creado
            </span>
            <span className="text-sm text-neutral-800">{formatDate(createdAt)}</span>
            {createdBy && (
              <span className="text-xs text-neutral-600 mt-1">
                <Icon icon="mdi:account" width="12" className="me-1" />
                {createdBy}
              </span>
            )}
          </div>
        </div>
        
        <div className="col-6">
          <div className="d-flex flex-column">
            <span className="text-xs text-neutral-500 mb-1">
              <Icon icon="mdi:calendar-edit" width="14" className="me-1" />
              Actualizado
            </span>
            <span className="text-sm text-neutral-800">{formatDate(updatedAt)}</span>
            {updatedBy && (
              <span className="text-xs text-neutral-600 mt-1">
                <Icon icon="mdi:account-edit" width="12" className="me-1" />
                {updatedBy}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditInfo;
